// extracted by mini-css-extract-plugin
export default {"buttonCentered":"button_buttonCentered__r-YUs","btn":"button_btn__vLmoj"};